import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, Grid, Table} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import {connect} from "react-redux";

import CustomDivider from '../../components/extras/CustomDivider';
import LineChartCurrency from '../../components/charts/LineChartCurrency';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ReportExpenses extends Component {
    constructor() {
        super();
        this.loadData = this.loadData.bind(this);
    }

    loadData(branch_office, date) {
        if(!localDB.checkPlanAccessExclude('reports_view_all')){
            this.refs.expenses_day_chart.loadData(branch_office, 'd', date);
            this.refs.expenses_week_chart.loadData(branch_office, 'w', date);
            this.refs.expenses_month_chart.loadData(branch_office, 'm', date);
            this.refs.expenses_montly_chart.loadData(branch_office, 'my', date);
            this.refs.expenses_year_chart.loadData(branch_office, 'y', date);
        }else {
            this.refs.alert_upgrade.open();
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Gráfico de Gastos - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Gráfico de Gastos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('reports_view_all') ? <Table>
                    <FilterBar title='Gráfico de Gastos' callbackGetFilter={this.loadData} colSpan={1}/>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={16}>
                                <br/>
                                <Grid stackable textAlign='center'>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <LineChartCurrency
                                                id='expenses_day_chart'
                                                title='Gastos Diarios'
                                                ref='expenses_day_chart'
                                                type='expenses'
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <LineChartCurrency
                                                title='Gastos Semanales'
                                                id='expenses_week_chart'
                                                ref='expenses_week_chart'
                                                type='expenses'
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <LineChartCurrency
                                                title='Gastos Mensuales'
                                                id='expenses_month_chart'
                                                ref='expenses_month_chart'
                                                type='expenses'
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <LineChartCurrency
                                                title='Gastos Anuales'
                                                id='expenses_montly_chart'
                                                ref='expenses_montly_chart'
                                                type='expenses'
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <LineChartCurrency
                                                title='Gastos desde el origen de los tiempos'
                                                id='expenses_year_chart'
                                                ref='expenses_year_chart'
                                                type='expenses'
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>:<UpgradeAccount/>}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        suscription: state.get('suscription'),
    };
};

export default connect(
    mapStateToProps
)(ReportExpenses);



// WEBPACK FOOTER //
// ./src/containers/reports/ReportExpenses.js